// extracted by mini-css-extract-plugin
export default {"tabelaDanychKontener":"Row_tabelaDanychKontener__G71Dz","tabelaKontener":"Row_tabelaKontener__ZWwER","glownaTabela":"Row_glownaTabela__j8jxy"};